//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'
import routes from '~/config/routes'
import EventBus from '~/eventBus'

export default {
    name: 'AppBar',

    props: ['show'],

    data: () => ({
        routes,
        loaded: false,
        apps: [

        ],
        p: [
            'Web',
            'YouTube Catcher',
            'Quality Management',
            'License Manager',
            'WP App Store',
            'WP Search Server',
        ]
    }),

    mounted(){
        // this.loadInnerContent()
    },

    computed: {

    },

    methods: {
        loadInnerContent(){
            if(!this.loaded)
            this.loadApps()
        },

        loadApps(){
            axios.get('/api/core/apps')
                 .then( r => {

                    if(r.data.apps)
                    this.apps = r.data.apps

                    setTimeout( () => {
                        this.loaded = true
                    }, 1)
                 })
                 .catch(e => console.log(e.response))
        },

        move(item){
            let url = item.url

            if(url)
            window.location = url
        }
    }
}
